/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleSecurityGroupResponse
 */
export interface RoleSecurityGroupResponse {
    /**
     * 
     * @type {any}
     * @memberof RoleSecurityGroupResponse
     */
    roleId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RoleSecurityGroupResponse
     */
    securityGroupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleSecurityGroupResponse
     */
    displayName?: string | null;
}

/**
 * Check if a given object implements the RoleSecurityGroupResponse interface.
 */
export function instanceOfRoleSecurityGroupResponse(value: object): value is RoleSecurityGroupResponse {
    return true;
}

export function RoleSecurityGroupResponseFromJSON(json: any): RoleSecurityGroupResponse {
    return RoleSecurityGroupResponseFromJSONTyped(json, false);
}

export function RoleSecurityGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleSecurityGroupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'roleId': json['roleId'] === undefined ? undefined : json['roleId'] === null ? null : json['roleId'],
        'securityGroupId': json['securityGroupId'] === undefined ? undefined : json['securityGroupId'] === null ? null : json['securityGroupId'],
        'displayName': json['displayName'] === undefined ? undefined : json['displayName'] === null ? null : json['displayName'],
    };
}

export function RoleSecurityGroupResponseToJSON(json: any): RoleSecurityGroupResponse {
    return RoleSecurityGroupResponseToJSONTyped(json, false);
}

export function RoleSecurityGroupResponseToJSONTyped(value?: RoleSecurityGroupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roleId': value['roleId'],
        'securityGroupId': value['securityGroupId'],
        'displayName': value['displayName'],
    };
}

